import type { App } from 'vue'

import MarsSelect from '@/components/mars/mars-select/index.vue'
import MarsInput from '@/components/mars/mars-input/index.vue'
import MarsTextarea from '@/components/mars/mars-textarea/index.vue'
import MarsInputNumber from '@/components/mars/mars-input-number/index.vue'
import MarsColorPicker from '@/components/mars/mars-color-picker/index.ts'
import MarsSwitch from '@/components/mars/mars-switch/index.vue'
import MarsSlider from '@/components/mars/mars-slider/index.vue'
import MarsButton from '@/components/mars/mars-button/index.vue'

export default function (app: App) {
  app.component('mars-select', MarsSelect)
  app.component('mars-input', MarsInput)
  app.component('mars-textarea', MarsTextarea)
  app.component('mars-input-number', MarsInputNumber)
  app.component('mars-color-picker', MarsColorPicker)
  app.component('mars-switch', MarsSwitch)
  app.component('mars-slider', MarsSlider)
  app.component('mars-button', MarsButton)
}
